<!-- src/views/OffersPage.vue -->

<template>
      <OffersList />
  </template>
  
  <script>
  import OffersList from '@/components/OffersList.vue';
  
  export default {
    name: 'OffersPage',
    components: {
      OffersList
    }
  }
  </script>
  